module.exports = __webpack_public_path__ + "static/media/main-large-section-2.9f5b95d8.png";